var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "91px",
    viewBox: "0 0 90 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dollar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-dollar-1",
    points: "0 0.315466667 89.6897812 0.315466667 89.6897812 90.2945736 0 90.2945736"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-dollar-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-dollar-page",
    transform: "translate(-156.000000, -1554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(156.000000, 1554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-dollar-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-dollar-3",
    transform: "translate(0.000000, 0.390101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-dollar-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-dollar-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-dollar-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.673375,75.5759938 C22.4042344,83.3286295 33.0544688,88.1121256 44.8451719,88.1121256 C56.6386875,88.1121256 67.2861094,83.3286295 75.01275,75.5759938 C82.7415,67.8184202 87.5122031,57.134738 87.5122031,45.3054434 C87.5122031,33.4740326 82.7415,22.7910558 75.01275,15.0334822 C67.2861094,7.28437364 56.6386875,2.49735039 44.8451719,2.49735039 C33.0544688,2.49735039 22.4042344,7.28437364 14.673375,15.0334822 C6.94532813,22.7910558 2.174625,33.4740326 2.174625,45.3054434 C2.174625,57.134738 6.94532813,67.8184202 14.673375,75.5759938 L14.673375,75.5759938 Z M44.8451719,90.294715 C32.4610313,90.2961256 21.2504063,85.2600868 13.1335313,77.1187612 C5.01876563,68.9767302 -0.001546875,57.7301178 -0.000140920353,45.3054434 C-0.001546875,32.8800636 5.01876563,21.6369783 13.1335313,13.4907147 C21.2504063,5.34868372 32.4610313,0.315466667 44.8451719,0.315466667 C57.2300156,0.315466667 68.4364219,5.34868372 76.5504844,13.4907147 C84.6701719,21.6327457 89.6897813,32.8800636 89.6897813,45.3054434 C89.6897813,57.7301178 84.6701719,68.9767302 76.5504844,77.1187612 C68.4399375,85.2600868 57.2335313,90.294715 44.8536094,90.294715 L44.8486875,90.294715 L44.8451719,90.294715 Z",
    id: "Fill-dollar-1",
    fill: "#D14200",
    mask: "url(#mask-dollar-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.3568359,59.8921085 L45.3568359,45.5437364 C50.8538672,47.3143566 52.3023047,49.7741783 52.3023047,53.0925039 C52.3023047,57.6051163 49.6128516,59.5478605 45.3568359,59.8921085 M36.3596484,35.408876 C36.3596484,32.2937132 38.1308203,29.5192713 42.8839453,29.258969 L42.8839453,42.0956124 C38.0112891,40.6128062 36.3596484,38.6566589 36.3596484,35.408876 M55.1956641,52.8815814 C55.1956641,48.3407519 53.1622266,45.1042558 45.3568359,42.7996279 L45.3568359,29.3422093 C49.2183984,29.8515271 50.9375391,32.1138295 51.7236328,34.9863256 L54.4587891,34.9863256 C54.1669922,32.1004264 52.1469141,27.5864031 45.3568359,26.9423488 L45.3568359,23.1097674 L42.8839453,23.1097674 L42.8839453,26.888031 C37.1808984,27.1970078 33.5190234,30.8271318 33.5190234,35.6734109 C33.5190234,40.8230233 36.7330078,43.0832093 42.8839453,44.8319612 L42.8839453,59.8963411 C39.3401953,59.5266977 36.2309766,57.1875039 35.4125391,52.9873953 L32.7294141,52.9873953 C33.2827734,58.134186 36.8715234,61.9209147 42.8839453,62.291969 L42.8839453,67.239124 L45.3568359,67.239124 L45.3568359,62.2736279 C51.7320703,61.8228605 55.1956641,58.3916667 55.1956641,52.8815814",
    id: "Fill-dollar-4",
    fill: "#D14200"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitDollarIcon);
export default __webpack_public_path__ + "static/media/benefit-dollar-icon.9d9acf54a0f492567d9c668b7701ad40.svg";
export { ForwardRef as ReactComponent };